module.exports = __webpack_public_path__ + "static/media/EG.e3b55a36.png";